import BlockCustomersTop from './customersTop'

export default BlockCustomersTop
